import { Line, LineConfig } from '@ant-design/charts'
import React, { useMemo } from 'react'

import { ChatterSalesDetail } from '@/model/analytics'

import ChatterSalesReportTooltip from './chatter-sales-report-tooltip'

export default function ChatterSalesReport({
  data = [],
}: { data?: ChatterSalesDetail[] }) {
  const chatterSalesConfig: LineConfig = useMemo(() => ({
    xField: 'dateStr',
    yField: 'earnings',
    shapeField: 'smooth',
    insetLeft: 20,
    insetRight: 20,
    axis: {
      x: {
        tick: false,
        labelAutoRotate: false,
        labelSpacing: 15,
      },
      y: {
        tick: false,
      },
    },
    point: {
      shapeField: 'circle',
      style: {
        stroke: '#3A5C40',
        fill: 'white',
        lineWidth: 2,
      },
      sizeField: '5',
      area: {
        zIndex: -100,
        shapeField: 'smooth',
        style: {
          fill: '#3A5C40',
          opacity: 0.1,
        },
      },
    },
    style: {
      stroke: '#3A5C40',
      lineWidth: 5,
    },
    tooltip(data: ChatterSalesDetail) {
      return { origin: data }
    },
    interaction: {
      tooltip: {
        render: (_: object, options: { items: { origin: ChatterSalesDetail }[] }) => {
          return (
            <div data-type="react">
              <ChatterSalesReportTooltip data={options.items[0].origin} />
            </div>
          )
        },
      },
    },
    height: 260,
  }
  ), [])

  return (
    <Line data={data} {...chatterSalesConfig} />
  )
}